<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="page_v"><span class="txit">To the people of Arizona, in gratitude for the privilege of representing them in the United States Senate</span></a></p><a id="page_v">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?339f0758